import { media } from "src/styles/mixins";
import styled, { css } from "styled-components";

export const GameWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  grid-template-rows: min-content auto min-content;
  grid-template-areas:
    "timer userCard tasks"
    "table table table"
    "deck deck deck";

  height: calc(100vh - var(--nav-height));
  overflow: hidden;
  margin-top: var(--nav-height);

  ${media.up("LAPTOP")`
    grid-template-rows: 1fr min-content;
    gap: 0px 0px;
    grid-template-areas:
      "timer table tasks"
      "timer deck tasks";
  `}
`;

export const BoardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  ${media.up("MOBILE")`
  min-height: calc(100vh - var(--nav-height));
  `}
`;

export const DeckWrapper = styled.div`
  grid-area: deck;
  width: 100%;
  z-index: 2;
  position: relative;
`;

export const EndTurnWrapper = styled.div`
  position: fixed;
  bottom: 0;
  width: 100%;
`;

export const TimerWrapper = styled.div`
  grid-area: timer;

  margin-top: 15px;
  margin-left: 16px;

  > div:nth-child(2) {
    margin-top: 18px;
  }

  ${media.up("LAPTOP")`
    margin-top: 50px;
    margin-left: 48px;

    > div:nth-child(2) {
    margin-top: 48px;
  }
  `}
  ${media.up("LAPTOP_LARGE")`
    margin-top:104px;
    margin-left: 96px;
  `}
`;

export const SpectatorLabel = styled.div`
  line-height: ${({ theme }) => theme.fonts.lineHeights.xxs};
  font-size: ${({ theme }) => theme.fonts.sizes.xxxs};
  margin-top: 6px;

  @media ${({ theme }) => theme.mq.md} {
    line-height: ${({ theme }) => theme.fonts.lineHeights.xs};
    font-size: ${({ theme }) => theme.fonts.sizes.xxs};
    margin-top: 8px;
  }
`;

export const ItemLabel = styled.p`
  line-height: ${({ theme }) => theme.fonts.lineHeights.xs};
  font-size: ${({ theme }) => theme.fonts.sizes.xxs};

  ${({ theme }) => css`
    ${media.down("MOBILE_SMALL")`
      line-height: ${theme.fonts.lineHeights.xxxs};
      font-size: 12px;
    `}
  `}
`;
